import { Controller } from "@hotwired/stimulus";
import debounce from "../lib/debounce";

export default class extends Controller {
  static targets = ["input", "results", "latitude", "longitude", "address"];

  connect() {
    this.search = debounce(this.fetchResults.bind(this), 500);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    document.addEventListener("click", this.handleClickOutside);
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside);
  }

  onInput() {
    const query = this.inputTarget.value.trim();
    if (query.length < 3) {
      this.hideResults();
      return;
    }
    this.search();
  }

  async fetchResults() {
    const query = this.inputTarget.value.trim();
    if (query.length < 3) return;

    const params = new URLSearchParams({
      format: "json",
      q: query,
      limit: "5",
      addressdetails: "1",
    });

    const country = this.currentCountry;
    if (country) {
      params.set("countrycodes", country.toLowerCase());
    }

    const response = await fetch(`https://nominatim.openstreetmap.org/search?${params}`, {
      headers: { Accept: "application/json" },
    });

    const results = await response.json();
    this.showResults(results);
  }

  showResults(results) {
    if (results.length === 0) {
      this.hideResults();
      return;
    }

    this.resultsTarget.innerHTML = results
      .map((result) => {
        const short = this.formatAddress(result.address);
        return `<button type="button" class="block w-full text-left px-3 py-2 text-sm hover:bg-fill-elevation-level-1 cursor-pointer" data-action="click->address-autocomplete#select" data-lat="${result.lat}" data-lon="${result.lon}" data-display-name="${this.escapeHtml(short)}">${this.escapeHtml(short)}</button>`;
      })
      .join("");

    this.resultsTarget.classList.remove("hidden");
  }

  formatAddress(address) {
    const street = address.road || address.pedestrian || address.footway || "";
    const number = address.house_number || "";
    const city = address.city || address.town || address.village || address.municipality || "";

    const streetLine = [street, number].filter(Boolean).join(" ");
    return [streetLine, city].filter(Boolean).join(", ");
  }

  select(event) {
    const { lat, lon, displayName } = event.currentTarget.dataset;

    this.inputTarget.value = displayName;
    this.latitudeTarget.value = lat;
    this.longitudeTarget.value = lon;
    this.addressTarget.value = displayName;

    this.hideResults();
  }

  hideResults() {
    this.resultsTarget.classList.add("hidden");
    this.resultsTarget.innerHTML = "";
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hideResults();
    }
  }

  get currentCountry() {
    const select = this.element.closest("form")?.querySelector("select[name*='country']");
    return select?.value || "";
  }

  escapeHtml(text) {
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
  }
}
